const mixin = {
  methods: {
    get_battery_style(soc) {
      let color = '#10c91a'
      if (soc <= 10) {
        color = 'red'
      }
      else if (soc > 10 && soc <= 20) {
        color = 'orange'
      }
      return {
        width: soc + '%',
        background: color
      }
    }
  }
}


export default mixin
